// extracted by mini-css-extract-plugin
module.exports = {"innerknob":"sliderTheme__innerknob--EX6gN","innerprogress":"sliderTheme__innerprogress--3TZMv","snaps":"sliderTheme__snaps--3OHwQ","snap":"sliderTheme__snap--NxGAR"};